export default __webpack_public_path__ + "static/media/tab-content-image-04.0b70a1b6.jpg";